import React from 'react';
// import logo from '../../assets/logo/pwa-512x512.png';
import logo from '../../assets/logo/intrasync_splash.png';
import symbol from '../../assets/logo/intrasync_industrial_symbol.png';

interface AppLogoProps {
  size?: number;
  height?: number;
  width?: number;
  background?: 'none' | 'gray' | 'white' | 'grayWhite' | 'black';
  symbolOnly?: boolean;
  styles?: React.CSSProperties;
}

class AppLogo extends React.PureComponent<AppLogoProps> {
  static defaultProps = {
    size: 128,
    background: 'none',
  };

  render() {
    const {
      size,
      height,
      width,
      background,
      symbolOnly,
      styles = {},
    } = this.props;
    return (
      <img
        src={symbolOnly ? symbol : logo}
        alt="logo"
        style={{
          width: width || size,
          height: height || size,
          backgroundColor: background,
          ...styles,
        }}
      />
    );
  }
}

export default AppLogo;
